module.exports = __webpack_public_path__ + "img/ydd_iphone.7ab9ff9c.png";